import { render, staticRenderFns } from "./Highscore.vue?vue&type=template&id=465a2856&scoped=true&"
import script from "./Highscore.vue?vue&type=script&lang=js&"
export * from "./Highscore.vue?vue&type=script&lang=js&"
import style0 from "./Highscore.vue?vue&type=style&index=0&id=465a2856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465a2856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VRow,VSimpleTable})
